import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { FretDivider, KanjiBackdrop, Seal } from './Ornaments';
import { bonuses, tomes } from '../data/bonuses';
const atlasCoverUrl = 'https://cdn.magicpatterns.com/uploads/dB76DHoBKWaoyqWyupcZ3h/Portada_Atlas_ancestral_de_acupuntura.png';
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-183" data-mp="dtu4jbh4npwg">
      <KanjiBackdrop glyphs={['經', '絡', '穴', '脈', '藥']} data-id="element-184" data-mp="dv5ddppfjnuf" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-185" data-mp="isnljdvmhz1d">
        <span className="inline-flex items-center gap-1.5 rounded-sm border border-brand-gold/60 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-brand-forest shadow-sm" data-id="element-186" data-mp="is5gbrqzgahb">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-187" data-mp="91aweu17lmz1" />
          Mirá el atlas por dentro
        </span>
        <h2 className="mt-3 font-display text-[28px] font-bold leading-[1.02] text-brand-ink sm:text-4xl md:text-5xl" data-id="element-188" data-mp="11k6nrihtp92c">
          Sin teoría interminable, sin libros de 500 páginas que nunca se usan en
          consulta:{' '}
          <span className="relative z-0 inline-block px-1.5 text-brand-burgundy before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.4em] before:-rotate-1 before:rounded-sm before:bg-brand-goldLight/90" data-id="element-189" data-mp="3ka4hrmz4cj73">
            el punto exacto
          </span>
          , la imagen exacta, la técnica exacta.
        </h2>
      </div>

      <div className="paper-card mx-auto mt-8 max-w-5xl rounded-sm border border-brand-gold/45 p-5 shadow-[0_14px_40px_rgba(44,38,32,0.09)] md:p-8" data-id="element-190" data-mp="6twxi2a7yjxt">
        <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:items-center sm:gap-8 sm:text-left" data-id="element-191" data-mp="lol8fvye2akt">
          <img src={atlasCoverUrl} alt="Portada del Atlas Ancestral de Acupuntura" className="w-40 shrink-0 rounded-sm border border-brand-gold/50 bg-brand-surfaceLight/40 object-contain shadow-[0_12px_28px_rgba(44,38,32,0.2)] sm:w-48 md:w-56" loading="lazy" decoding="async" data-id="element-192" data-mp="2ni0zuv2avtgu" />
          <div className="min-w-0" data-id="element-193" data-mp="3c9gckmjzyjeo">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-burgundy" data-id="element-194" data-mp="3cai1nuxul6fe">
              El pack principal
            </span>
            <h3 className="mt-1.5 font-serif text-2xl font-bold leading-tight text-brand-ink md:text-[2rem]" data-id="element-195" data-mp="3m7w4usurfypr">
              ATLAS ANCESTRAL DE ACUPUNTURA™
            </h3>
            <p className="mt-3 max-w-xl font-display text-lg leading-snug text-brand-text md:text-xl" data-id="element-196" data-mp="3v7awvwqkshcd">
              Tu sistema visual completo para localizar el punto correcto,
              aplicarlo con técnica precisa y respaldarte con criterio clínico en
              cada sesión.
            </p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.12em] text-brand-goldDark" data-id="element-197" data-mp="drb0xqgzjvti">
              3 tomos · 118 páginas · 26 protocolos clínicos
            </p>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-4 divide-x divide-brand-gold/35 rounded-sm border border-brand-gold/40 bg-brand-surfaceLight/45 px-2 py-3 text-center" data-id="element-198" data-mp="238pxklwfu5rc">
          <div className="px-1" data-id="element-199" data-mp="1ybg7d4185q2g">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-200" data-mp="1t97cu38pefy8">
              3
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-201" data-mp="1oc7g4ixqupjs">
              tomos
            </span>
          </div>
          <div className="px-1" data-id="element-202" data-mp="2gzuvnjk5qpzk">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-203" data-mp="2h0w9fvsk5qkz">
              118
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-204" data-mp="2c6s39er49mky">
              páginas
            </span>
          </div>
          <div className="px-1" data-id="element-205" data-mp="34q7dbm57g13c">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-206" data-mp="34r8r3ydlv1or">
              26
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-207" data-mp="2kgpgf45lnej3">
              protocolos
            </span>
          </div>
          <div className="px-1" data-id="element-208" data-mp="2pgu0131t0pdj">
            <strong className="block font-serif text-lg leading-none text-brand-forest" data-id="element-209" data-mp="2aii10pqyl4j7">
              50+
            </strong>
            <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.1em] text-brand-muted" data-id="element-210" data-mp="2fie66sbe720c">
              puntos
            </span>
          </div>
        </div>

        <ul className="mt-6 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-211" data-mp="385qqswxzszr0">
          {tomes.map(tome => <li key={tome.label} className="flex gap-3 md:flex-col md:gap-3" data-id="element-212" data-mp="2thnmrt3ify4u">
              <div className="relative mt-0.5 w-14 shrink-0 md:mx-auto md:mt-0 md:w-24" data-id="element-213" data-mp="2yg7a9xxr5hzb">
                <img src={tome.cover} alt={`Portada del ${tome.label}: ${tome.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-full rounded-sm border border-brand-ink/25 bg-brand-ink object-cover shadow-[0_6px_14px_rgba(44,38,32,0.22)]" data-id="element-214" data-mp="2yduiyu63tv9l" />
                <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-sm border border-brand-gold/60 bg-brand-paper font-kanji text-[10px] text-brand-goldDark" aria-hidden="true" data-id="element-215" data-mp="1ahn13502t616">
                  {tome.numeral}
                </span>
              </div>
              <div className="min-w-0 md:text-center" data-id="element-216" data-mp="rjk6maoregvz">
                <p className="font-serif text-sm font-bold text-brand-ink" data-id="element-217" data-mp="rl4yttnlpnqo">
                  <span className="uppercase tracking-[0.08em] text-brand-burgundy" data-id="element-218" data-mp="15kefsvjmslvp">
                    {tome.label}
                  </span>{' '}
                  — {tome.title}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-brand-muted" data-id="element-219" data-mp="2gxgvzphtj9fc">
                  {tome.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 border-t border-brand-gold/30 pt-4 text-sm leading-relaxed text-brand-muted md:text-center" data-id="element-220" data-mp="19mskkw0l9f2e">
          Localización exacta del punto, meridiano de pertenencia, órgano
          asociado, técnica de inserción y acción terapéutica en una consulta
          rápida.
        </p>
      </div>

      <FretDivider character="贈" className="mt-14" data-id="element-221" data-mp="1nkh7sai4oyam" />
      <div className="mt-6 text-center" data-id="element-222" data-mp="qvhzwwlghyiy">
        <h3 className="flex flex-wrap items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-223" data-mp="qwkqt4is40yv">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-224" data-mp="vuuj97d4cngs" />
          6 BONOS ESTRATÉGICOS —
          <span className="text-brand-forest" data-id="element-225" data-mp="14mo6tdr2eyfv">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-226" data-mp="8508cvcd18z6">
        {bonuses.map(bonus => <article key={bonus.n} className="min-w-0" data-id="element-227" data-mp="c5k3xuhac4j7">
            <div className="aspect-[3/4] overflow-hidden rounded-sm border border-brand-ink/25 bg-brand-ink shadow-[0_10px_24px_rgba(44,38,32,0.22)]" data-id="element-228" data-mp="c491bxzkt2to">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-229" data-mp="3vugktnw3fkvd" />
            </div>
            <p className="mt-2 text-center text-[10px] font-bold uppercase tracking-wide text-brand-burgundy" data-id="element-230" data-mp="3hu5vwqecggcu">
              Bono {bonus.n} — {bonus.title}
            </p>
            <p className="mt-1 min-h-[3.75rem] text-center text-[10px] leading-tight text-brand-muted" data-id="element-231" data-mp="3d12yg76g4mrd">
              {bonus.description}
            </p>
            <p className="mt-2 text-center text-[10px] text-brand-muted" data-id="element-232" data-mp="343iw0uwukkf6">
              <span className="line-through" data-id="element-233" data-mp="2z3o4cp58zqt2">{bonus.price}</span>{' '}
              <strong className="text-brand-forest" data-id="element-234" data-mp="2z4zc101tdipg">→ GRATIS</strong>
            </p>
          </article>)}
      </div>
      <div className="mt-8 flex justify-center" data-id="element-235" data-mp="luu00dijcr69">
        <span className="inline-flex items-center gap-3 rounded-sm border border-brand-gold/55 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-236" data-mp="lw50o4gopit5">
          <Seal characters="贈禮" className="h-9 w-9 text-[11px]" data-id="element-237" data-mp="cvglv7jgvef7" />
          <span data-id="element-238" data-mp="htqiznor4p3g">
            Valor total de los bonos{' '}
            <span className="text-brand-muted line-through" data-id="element-239" data-mp="hs71jtrd0803">$76.000 ARS</span>{' '}
            <strong className="text-brand-forest" data-id="element-240" data-mp="33szvm5oipl4">
              → GRATIS con tu Atlas Ancestral
            </strong>
          </span>
        </span>
      </div>
    </Section>;
}